import { IEntityDetails, IProductDetails, PRODUCT_KEY } from '../types';

export const getApplicationByKey = (entity: IEntityDetails, appKey: PRODUCT_KEY): IProductDetails | undefined => {
  return entity.entitledApplications.find((app: IProductDetails) => app.entitlementProductKey === appKey);
};

export const getEntityDefaultApplication = (entity: IEntityDetails): IProductDetails | undefined => {
  let application;

  const defaultEntityApplication = entity.entitledApplications.find((app: IProductDetails) => app.defaultApp);
  if (defaultEntityApplication) {
    application = defaultEntityApplication;
  }

  // If there is only one entitled application, open it without displaying the selection dialog
  const singleEntitledApplication = entity.entitledApplications.length === 1;
  if (singleEntitledApplication) {
    application = entity.entitledApplications[0];
  }

  return application;
};
